export const UPDATE_EVENT_LIST = 'event/UPDATE_EVENT_LIST';
export const APPEND_EVENT_LIST = 'event/APPEND_EVENT_LIST';
export const LOADING_EVENTS = 'event/LOADING_EVENTS';
